// MUI theme for the restaurant Driver Payouts, Per-Driver Pay Override and
// Driver Payout Requests pages ONLY (MyDriverPayouts.jsx, MyDriverOverride.jsx,
// DriverPayoutRequests.jsx).
//
// It is the Promotions theme (ink / amber, orange focus ring, no green / blue /
// indigo / purple, labels above 48px fields, 44x26 switches) plus the driver
// picker's dropdown and indicator buttons and a destructive outlined button.
import React from 'react'
import { createTheme } from '@mui/material/styles'
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded'
import { promotionsTheme, PM, focusRing } from './promotionsTheme'

export const DP = {
  ...PM,
  destructiveBorder: '#E5A3A3',
  segmentTrack: '#E4E7EC'
}

export { focusRing }

const extra = base => ({
  MuiAutocomplete: {
    defaultProps: { popupIcon: React.createElement(KeyboardArrowDownRoundedIcon) },
    styleOverrides: {
      ...base.components.MuiAutocomplete.styleOverrides,
      root: {
        ...base.components.MuiAutocomplete.styleOverrides.root,
        // Room for two 44px indicator buttons inside the field.
        '&.MuiAutocomplete-hasPopupIcon .MuiAutocomplete-inputRoot.MuiOutlinedInput-root': { paddingRight: 52 },
        '&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot.MuiOutlinedInput-root': { paddingRight: 96 },
        // MUI already centres the adornment (top 50% + translate); only pull it in.
        '& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment': { right: 4, display: 'flex', alignItems: 'center' }
      },
      clearIndicator: { width: 44, height: 44, borderRadius: 10, color: DP.secondary, '&.Mui-focusVisible': focusRing },
      popupIndicator: { width: 44, height: 44, borderRadius: 10, color: DP.secondary, '&.Mui-focusVisible': focusRing },
      paper: {
        marginTop: 6,
        backgroundColor: '#FFFFFF',
        backgroundImage: 'none',
        fontFamily: DP.font,
        borderRadius: 12,
        border: `1px solid ${DP.border}`,
        boxShadow: '0 12px 32px rgba(15, 23, 42, 0.18)'
      },
      listbox: { padding: 6 },
      option: {
        minHeight: '44px !important',
        borderRadius: 8,
        '&[aria-selected="true"]': { backgroundColor: `${DP.paleAmber} !important` },
        '&.Mui-focused': { backgroundColor: `${DP.page} !important` },
        '&[aria-selected="true"].Mui-focused': { backgroundColor: `${DP.paleAmber} !important` }
      },
      noOptions: { fontSize: 14, color: DP.secondary },
      loading: { fontSize: 14, color: DP.secondary }
    }
  },
  MuiButton: {
    styleOverrides: {
      ...base.components.MuiButton.styleOverrides,
      outlinedError: {
        backgroundColor: '#FFFFFF',
        border: `1px solid ${DP.destructiveBorder}`,
        color: DP.danger,
        '&:hover': { backgroundColor: '#FEF2F2', borderColor: DP.danger }
      }
    }
  }
})

export const driverPayTheme = outer => {
  const base = promotionsTheme(outer)
  return createTheme({ ...base, components: { ...base.components, ...extra(base) } })
}
